import { Observable } from "../../utils/observable";
import { MandateStatus } from "./mandate";

export class MandateFilterManager {
  public statusSelection = new Observable<MandateStatus>(MandateStatus.ALL);

  setStatusSelection(status: MandateStatus) {
    this.statusSelection.set(status);
  }

  public clear() {
    this.statusSelection.set(MandateStatus.ALL);
  }
}
